// extracted by mini-css-extract-plugin
export const wrapper = "hero-module--wrapper--3cr9h";
export const wrapper__noIllustration = "hero-module--wrapper__noIllustration--fCB1q";
export const container = "hero-module--container--3xd-m";
export const copyContainer = "hero-module--copyContainer--ffK_F";
export const container__noIllustration = "hero-module--container__noIllustration--3cvvn";
export const title = "hero-module--title--Eeqbu";
export const lead = "hero-module--lead--2dzrH";
export const illustration = "hero-module--illustration--ZnUZq";
export const svgBox = "hero-module--svgBox--1YC8u";